import {useEffect, useState} from 'react';
import {isUndefined} from 'lodash';

import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import Button from '@mui/material/Button';

import {setTelegramUserNotifications} from '../../Helpers/bot';

import {useToasterStore} from '../../../../Stores/toster';

import Preloader from '../../../../Components/Preloaders/Preloader';

export default function TelegramNotifications(props) {
    const {config, onSubmit} = props;

    const [notificationsConfig, setNotificationsConfig] = useState();

    const [notificationsChangeInProgress, setNotificationsChangeInProgress] = useState();
    const [configWasChanged, setConfigWasChanged] = useState(false);
      
    useEffect(() => {
        setNotificationsConfig({...config})
    }, [config])

    const {showError} = useToasterStore();

    const onAllEventsChange = (e) => {
        const config = {...notificationsConfig}
        config.events = e.target.checked
        // Object.keys(config.events).map(event => {
        //   config.events[event] = e.target.checked
        // })
        setNotificationsConfig(config)
        setConfigWasChanged(true)
    }

    const onSystemNotificationsChange = (e) => {
        const config = {...notificationsConfig}
        config.system = e.target.checked
        setNotificationsConfig(config)
        setConfigWasChanged(true)
    }

    const onNotificationsChange = (e) => {
        setNotificationsChangeInProgress(true)

        setTelegramUserNotifications("prostir", notificationsConfig)
          .then(() => {
            setTimeout(() => {
              setNotificationsChangeInProgress(false)
              setConfigWasChanged(false)
            }, 1000)
            if (onSubmit) onSubmit()
          })
          .catch((e) => {
            console.log(e)
            showError({
              snackbarMessage: 'Виникла помилка збереження даних',
            })
            setNotificationsChangeInProgress(false)
          })
    }

    return <>
        {notificationsChangeInProgress && <Preloader />}
        <div>Яку інформацію ви хочете отримувати у телеграм бот?</div>
        <br/>

        {notificationsConfig && <div className="NotificationsConfiguration">
            {/* <div className="bot">Телеграм бот @MiyProstirBot:</div> */}

            {/* {configs?.filters?.default?.events?.values &&  */}
            <div className="block">
            <div className="sectionTitle">
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={notificationsConfig?.events || isUndefined(notificationsConfig?.events)}
                            onChange={onAllEventsChange}
                        />
                    }
                    label="Події"
                />
                {/* Події за типом */}
            </div>

            {/* <div className="section">
                {Object.keys(configs.filters.default.events.values).map(event => <div className="item">
                <FormControlLabel
                    control={
                    <Checkbox
                        // checked={value}
                        onChange={(e) => {onEventChange(e, event)}}
                    />
                    }
                    label={configs.filters.default.events.values[event]}
                />
                </div>)}
            </div> */}

            {/* [ ] Новини та Інші секції */}

            <div className="sectionTitle">
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={notificationsConfig?.system || isUndefined(notificationsConfig?.system)}
                            onChange={onSystemNotificationsChange}
                        />
                    }
                    label="Системні сповіщення"
                />
            </div>

            <div>
                <Button
                    fullWidth
                    variant="contained"
                    onClick={onNotificationsChange}
                    disabled={!configWasChanged}
                >
                    Зберегти
                </Button>
            </div>
            </div>
        </div>}
    </>
}
